var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 421,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16A15 15 0 0 1 15 1h470a15 15 0 0 1 15 15v323.6a15 15 0 0 1-11 14.5l-235 65.8a15 15 0 0 1-8 0L11 354a15 15 0 0 1-11-14.5V16Z",
    fill: "#FA2323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m186 1 53.5 107h-9l-68-107H186Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m225 1 20 103.5h-6.5L205.4 1H225Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m260 1-6 105h-8.5L242 1h18Z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m297 1-33.5 104h-4L283 1h14Z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m341 1-67.5 103.5h-10L317 1h24Z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M404 1 288 106.5h-15L370.5 1H404Z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m102.5 1 118 108.5H232L135 1h-32.5Z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m500 88-217.5 45v-9L500 56.5V88Z",
    fill: "url(#h)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 79.5 220.5 129l1-8.5L0 48v31.5Z",
    fill: "url(#i)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m500 155-219-12v-10l219-7v29Z",
    fill: "url(#j)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m0 144.5 218.5-9v-8L0 115.5v29Z",
    fill: "url(#k)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m500 224-221.5-73v-8.5l221.5 49V224Z",
    fill: "url(#l)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m0 213 216.5-69.8v-7.7L0 181v32Z",
    fill: "url(#m)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m500 308.5-222.5-147V151L500 269v39.5Z",
    fill: "url(#n)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m0 290.5 221.5-139.9v-9.1L0 254.5v36Z",
    fill: "url(#o)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382 411 251.5 159.6H262L420 411h-38Z",
    fill: "url(#p)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m101 411 134-252.5h-12L63 411h38Z",
    fill: "url(#q)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m0 401 226-244.5-7.5-3L0 349.5V401Z",
    fill: "url(#r)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m297.6 411-51.8-256.6h5.5L334 411h-36.4Z",
    fill: "url(#s)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 411 241 155.4h-6.4l-84 255.6h33.9Z",
    fill: "url(#t)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m225.5 411 16-254.5h7l9 254.5h-32Z",
    fill: "url(#u)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m489.5 411-224-245.5 3-11.5L500 371.5V411h-10.5Z",
    fill: "url(#v)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M500 13 297 117h-22L459.5 1H500v12Z",
    fill: "url(#w)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m0 3 223.5 119.5v-10L52.8 1H0v2Z",
    fill: "url(#x)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30 194c.2-.5.8-.5 1 0l6 12.2.4.2 13.5 2c.4 0 .6.6.3.9l-9.8 9.5-.2.4 2.4 13.5c0 .4-.4.7-.8.5l-12-6.3h-.5l-12.1 6.3a.5.5 0 0 1-.8-.5l2.4-13.5c0-.1 0-.3-.2-.4l-9.8-9.5a.5.5 0 0 1 .3-.9l13.5-2c.2 0 .3 0 .4-.2l6-12.3ZM100.1 274.8a1 1 0 0 1 1.8 0l4.7 9.6c.2.3.5.5.8.6l10.6 1.5a1 1 0 0 1 .6 1.7l-7.7 7.5a1 1 0 0 0-.3 1l1.8 10.5a1 1 0 0 1-1.4 1l-9.5-5a1 1 0 0 0-1 0l-9.5 5a1 1 0 0 1-1.4-1l1.8-10.6c0-.3 0-.6-.3-.9l-7.7-7.5a1 1 0 0 1 .6-1.7l10.6-1.5c.3 0 .6-.3.8-.6l4.7-9.6Z",
    fill: "#B41616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 274c.1-.5.7-.5.8 0l5.4 10.7.3.2 12 1.8c.3 0 .5.5.2.8l-8.6 8.4c-.1.1-.2.3-.1.4l2 11.9c0 .4-.4.7-.7.5l-10.7-5.6h-.4L90 308.7a.5.5 0 0 1-.7-.5l2-11.9-.1-.4-8.6-8.4a.5.5 0 0 1 .3-.8l11.9-1.8c.1 0 .3 0 .3-.2l5.4-10.8ZM154 322c.2-.5.8-.5 1 0l1.6 3.2c0 .2.2.3.4.3l3.6.5c.4.1.6.6.3.9l-2.6 2.6c-.2 0-.2.3-.2.4l.6 3.7c.1.4-.3.7-.7.5l-3.3-1.7c-.1-.1-.3-.1-.4 0L151 334a.5.5 0 0 1-.7-.5l.6-3.7c0-.1 0-.3-.2-.4l-2.6-2.6a.5.5 0 0 1 .3-.9l3.6-.5c.2 0 .3-.1.4-.3l1.7-3.3ZM306.4 351.2h.2l.6 1.2v.1l1.5.2v.2l-1 1 .2 1.4c0 .1 0 .2-.1.1l-1.3-.6-1.3.6h-.1l.2-1.5-1-1v-.2l1.4-.2.7-1.3ZM216.6 346c.1-.5.7-.5.8 0l2.4 4.7c0 .2.2.3.4.3l5.3.8c.4 0 .6.5.3.8l-3.9 3.8-.1.4 1 5.3c0 .4-.5.7-.8.5l-4.8-2.5h-.4l-4.8 2.5a.5.5 0 0 1-.7-.5l.9-5.3-.1-.4-3.9-3.8a.5.5 0 0 1 .3-.8l5.3-.8c.2 0 .3-.1.4-.3l2.4-4.8ZM417.6 316c.1-.5.7-.5.8 0l2.4 4.7c0 .2.2.3.4.3l5.3.8c.4 0 .6.5.3.8l-3.9 3.8-.1.4 1 5.3c0 .4-.5.7-.8.5l-4.8-2.5h-.4l-4.8 2.5a.5.5 0 0 1-.7-.5l.9-5.3-.1-.4-3.9-3.8a.5.5 0 0 1 .3-.8l5.3-.8c.2 0 .3-.1.4-.3l2.4-4.8ZM348.6 362c.1-.5.7-.5.8 0l2.4 4.7c0 .2.2.3.4.3l5.3.8c.4 0 .6.5.3.8l-3.9 3.8-.1.4 1 5.3c0 .4-.5.7-.8.5l-4.8-2.5h-.4l-4.8 2.5a.5.5 0 0 1-.7-.5l.9-5.3-.1-.4-3.9-3.8a.5.5 0 0 1 .3-.8l5.3-.8c.2 0 .3-.1.4-.3l2.4-4.8ZM493 277c.2-.5.8-.5 1 0l3 6.2c.1.2.3.3.4.3l2.2.3c.2 0 .4.3.4.5v13.3c0 .4-.4.7-.8.5l-5.5-3.2c-.1-.1-.3-.1-.4 0L487 298a.5.5 0 0 1-.7-.5l1.2-7-.1-.4-5-4.9a.5.5 0 0 1 .2-.8l7-1c.1 0 .3-.1.3-.3l3.2-6.3ZM51.6 91c.1-.5.7-.5.8 0l3.9 7.7.4.3 8.6 1.2c.4 0 .5.6.2.9l-6.2 6c-.1.1-.2.3-.1.5l1.4 8.5c.1.4-.3.8-.7.6l-7.7-4c-.1-.2-.3-.2-.4 0l-7.7 4a.5.5 0 0 1-.7-.6l1.4-8.5-.1-.5-6.2-6a.5.5 0 0 1 .2-.9l8.6-1.2c.2 0 .3-.2.4-.3l3.9-7.8ZM116.5 1c.6 0 .7.8.1 1l-4.3 1c-.3.2-.4.4-.4.7l1.7 10c0 .4-.3.7-.7.5l-9.2-4.8c-.1-.1-.3-.1-.4 0L94 14.2a.5.5 0 0 1-.7-.5l1.7-10c0-.3-.1-.5-.4-.6l-4-1.1c-.5-.2-.4-1 .2-1h25.6ZM488.3 1c.1 0 .3 0 .3.2l1 1.1.3.2 3.7.5c.4.1.6.6.3.9l-2.6 2.6c-.2 0-.2.3-.2.4l.6 3.7c.1.4-.3.7-.7.5l-3.3-1.7c-.1-.1-.3-.1-.4 0L484 11a.5.5 0 0 1-.7-.5l.6-3.7c0-.1 0-.3-.2-.4l-2.6-2.6a.5.5 0 0 1 .3-.9l3.7-.5.3-.2.7-1c.1-.2.3-.3.5-.3h1.7ZM420 24c.2-.5.8-.5 1 0l3 6.2c.1.2.3.3.4.3l7 1c.4 0 .6.6.3.8l-5 5c-.2 0-.2.2-.2.4l1.2 7c0 .3-.4.6-.7.4l-6.3-3.2c-.1-.1-.3-.1-.4 0L414 45a.5.5 0 0 1-.7-.5l1.2-7-.1-.4-5-4.9a.5.5 0 0 1 .2-.8l7-1c.1 0 .3-.1.3-.3l3.2-6.3Z",
    fill: "#B41616"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B41616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B41616",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B41616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41616",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusInfoRed);
export default __webpack_public_path__ + "static/media/bonus-info-red.412e1ce3fe66f800af053dbc3aa92e02.svg";
export { ForwardRef as ReactComponent };